import React from "react";
import "./inspired-by.scss";
import { Row, Col } from "reactstrap";

function InspiredBy() {
  return (
    <div className="inspired-by-container text-center">
      <h3 className={"title"}>Insured by</h3>
      <Row className="m-0 p-0">
        <Col
          lg="4"
          xs="12"
          md="12"
          sm="12"
          className="m-0 p-0 d-flex justify-content-center align-items-center"
        >
          <img
            className="chola"
            src={require("../../../assets/images/chola.png")}
            alt=""
          />
        </Col>
        <Col
          lg="4"
          xs="12"
          md="12"
          sm="12"
          className="m-0 p-0 d-flex justify-content-center align-items-center"
        >
          <img
            className="religare"
            src={require("../../../assets/images/religare.svg")}
            alt=""
          />
        </Col>
        <Col
          lg="4"
          xs="12"
          md="12"
          sm="12"
          className="m-0 p-0 d-flex justify-content-center align-items-center"
        >
          <img
            className="indiafirst"
            src={require("../../../assets/images/icici.svg")}
            alt=""
          />
        </Col>
      </Row>
    </div>
  );
}

export default InspiredBy;
